import { css } from "@vitality-ds/system";
import { getGhostVariant, getLinkVariant, getOnSolidBackgroundVariant, getOnSurfaceVariant, getOnUiElementBackgroundVariant, getSolidVariant, getUiElementVariant } from "./helpers";
export default css({
  $$fontSize: "$fontSizes$caption",
  $$paddingHorizontal: "$space$sm",
  fontSize: "$$fontSize",
  fontWeight: "$caption",
  "&, kbd": {
    fontFamily: "$body",
    lineHeight: "$caption",
    boxSizing: "border-box"
  },
  borderRadius: "$default",
  display: "inline-flex",
  padding: "$xs $$paddingHorizontal",
  justifyContent: "center",
  alignItems: "center",
  alignSelf: "center",
  minWidth: "calc($$fontSize + $$paddingHorizontal * 2)",
  variants: {
    /**
     * When combinedKeys = true, adds spacing between characters
     */
    separateCombinedKeys: {
      "true": {
        gap: "$xs"
      }
    },
    /**
     * The stylistic changes in the element (Internal Prop - Not Exposed)
     * Note that these variants are empty on purpose
     * to allow for the compound variants
     */
    variant: {
      uiElement: {},
      uiElementSolid: {},
      onSolidBackground: {},
      onUiElementBackground: {},
      onSurfaceBackground: {},
      ghost: {},
      link: {}
    },
    /**
     * The tint of the element (Internal Prop - Not Exposed)
     * Note that these variants are empty on purpose
     * to allow for the compound variants
     */
    color: {
      neutral: {},
      primary: {},
      critical: {},
      success: {},
      warning: {},
      info: {},
      brand: {},
      accent: {}
    }
  },
  compoundVariants: [
  /**
   * Standard Variants
   */
  {
    color: "neutral",
    variant: "uiElement",
    css: getUiElementVariant("neutral")
  }, {
    color: "primary",
    variant: "uiElement",
    css: getUiElementVariant("primary")
  }, {
    color: "success",
    variant: "uiElement",
    css: getUiElementVariant("success")
  }, {
    color: "warning",
    variant: "uiElement",
    css: getUiElementVariant("warning")
  }, {
    color: "critical",
    variant: "uiElement",
    css: getUiElementVariant("critical")
  }, {
    color: "info",
    variant: "uiElement",
    css: getUiElementVariant("info")
  }, {
    color: "brand",
    variant: "uiElement",
    css: getUiElementVariant("brand")
  }, {
    color: "accent",
    variant: "uiElement",
    css: getUiElementVariant("accent")
  },
  /**
   * Solid Variants
   */
  {
    color: "neutral",
    variant: "uiElementSolid",
    css: getSolidVariant("neutral")
  }, {
    color: "primary",
    variant: "uiElementSolid",
    css: getSolidVariant("primary")
  }, {
    color: "success",
    variant: "uiElementSolid",
    css: getSolidVariant("success")
  }, {
    color: "warning",
    variant: "uiElementSolid",
    css: getSolidVariant("warning")
  }, {
    color: "critical",
    variant: "uiElementSolid",
    css: getSolidVariant("critical")
  }, {
    color: "info",
    variant: "uiElementSolid",
    css: getSolidVariant("info")
  }, {
    color: "brand",
    variant: "uiElementSolid",
    css: getSolidVariant("brand")
  }, {
    color: "accent",
    variant: "uiElementSolid",
    css: getSolidVariant("accent")
  },
  /**
   * onUiElementBackground Variants
   */
  {
    color: "neutral",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("neutral")
  }, {
    color: "primary",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("primary")
  }, {
    color: "success",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("success")
  }, {
    color: "warning",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("warning")
  }, {
    color: "critical",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("critical")
  }, {
    color: "info",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("info")
  }, {
    color: "brand",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("brand")
  }, {
    color: "accent",
    variant: "onUiElementBackground",
    css: getOnUiElementBackgroundVariant("accent")
  },
  /**
   * OnSurface Variants
   */
  {
    color: "neutral",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("neutral")
  }, {
    color: "primary",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("primary")
  }, {
    color: "success",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("success")
  }, {
    color: "warning",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("warning")
  }, {
    color: "critical",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("critical")
  }, {
    color: "info",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("info")
  }, {
    color: "brand",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("brand")
  }, {
    color: "accent",
    variant: "onSurfaceBackground",
    css: getOnSurfaceVariant("accent")
  },
  /**
   * Ghost Variants
   */
  {
    color: "neutral",
    variant: "ghost",
    css: getGhostVariant("neutralA")
  }, {
    color: "primary",
    variant: "ghost",
    css: getGhostVariant("primary")
  }, {
    color: "success",
    variant: "ghost",
    css: getGhostVariant("success")
  }, {
    color: "warning",
    variant: "ghost",
    css: getGhostVariant("warning")
  }, {
    color: "critical",
    variant: "ghost",
    css: getGhostVariant("critical")
  }, {
    color: "info",
    variant: "ghost",
    css: getGhostVariant("info")
  }, {
    color: "brand",
    variant: "ghost",
    css: getGhostVariant("brand")
  }, {
    color: "accent",
    variant: "ghost",
    css: getGhostVariant("accent")
  },
  /**
   * Link Variants
   */
  {
    color: "neutral",
    variant: "link",
    css: getLinkVariant("neutralA")
  }, {
    color: "primary",
    variant: "link",
    css: getLinkVariant("primary")
  }, {
    color: "success",
    variant: "link",
    css: getLinkVariant("success")
  }, {
    color: "warning",
    variant: "link",
    css: getLinkVariant("warning")
  }, {
    color: "critical",
    variant: "link",
    css: getLinkVariant("critical")
  }, {
    color: "info",
    variant: "link",
    css: getLinkVariant("info")
  }, {
    color: "brand",
    variant: "link",
    css: getLinkVariant("brand")
  }, {
    color: "accent",
    variant: "link",
    css: getLinkVariant("accent")
  },
  /**
   * Solid Variants
   */
  {
    color: "neutral",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("neutral")
  }, {
    color: "primary",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("primary")
  }, {
    color: "success",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("success")
  }, {
    color: "warning",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("warning")
  }, {
    color: "critical",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("critical")
  }, {
    color: "info",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("info")
  }, {
    color: "brand",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("brand")
  }, {
    color: "accent",
    variant: "onSolidBackground",
    css: getOnSolidBackgroundVariant("accent")
  }]
});